import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/yellowcalf.css/RootLayout.css";
import "../Styles/yellowcalf.css/Sidebar.css";
import Header from "./Header/Header";
import logo from "../images/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGears, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { faMoneyBill1 } from "@fortawesome/free-regular-svg-icons";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

function App() {
  return <FontAwesomeIcon icon={faGears} />;
}

const RootLayout = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  // Accordion submenu state
  const [openSubmenus, setOpenSubmenus] = useState(null);

  // Toggle function (only one open at a time)
  const toggleSubMenu = (menuKey) => {
    setOpenSubmenus((prev) => (prev === menuKey ? null : menuKey));
  };
  const handleLogout = (e) => {
    // Prevent the default link behavior if necessary
    e.preventDefault();

    // 1. Clear all data from localStorage
    localStorage.clear();

    // OR clear specific items only:
    // localStorage.removeItem("api_key");
    // localStorage.removeItem("user_id");
    // localStorage.removeItem("customer_id");

    // 2. Redirect the user to the login page
    navigate("/login");
  };
  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 768;
      setIsMobile(isSmallScreen);
      setIsSidebarOpen(!isSmallScreen);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="layout">
      <aside className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <nav id="pageslide-left" className="pageslide inner">
          <div className="navbar-content" style={{ height: "648px" }}>
            <div
              className="main-navigation left-wrapper transition-left ps-container"
              style={{ height: "648px" }}
            >
              {/* Clock & settings */}
              <div className="sidebar-header">
                {/* {isMobile && ( */}

                {/* )} */}
                {isSidebarOpen ? (
                  <div className="d-flex align-items-center gap-2 p-2">
                    <img
                      src={logo}
                      alt="Logo"
                      className="flex-shrink-0 me-2"
                      style={{ maxWidth: "100%", maxHeight: "6rem" }}
                    />
                  </div>
                ) : null}
              </div>

              {/* Main navigation */}
              <ul className="main-navigation-menu">
                {/* Dashboard */}
                <li>
                  <Link to="/accountant">
                    <i
                      class="bi bi-speedometer2"
                      size="sm"
                      style={{ marginRight: "8px" }}
                    ></i>
                    <span className="title">Dashboard</span>
                    <span
                      className="label label-default pull-right"
                      style={{ fontSize: "75%"}}
                    >
                      Accountant
                    </span>
                  </Link>
                </li>

                {/* Master Settings */}
                <li>
                  <a href="#!" onClick={() => toggleSubMenu("masterSettings")}>
                    <FontAwesomeIcon
                      icon={faGears}
                      size="sm"
                      style={{ marginRight: "8px" }}
                    />
                    <span className="title">Master Settings</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "masterSettings" && (
                    <ul className="sub-menu">
                      <li>
                        <Link to="/Feefrequency">Fee Frequency</Link>
                      </li>
                      <li>
                        <Link to="/Feecategory">Fee Category</Link>
                      </li>
                      <li>
                        <Link to="/Feestructure">Fee Structure</Link>
                      </li>
                      <li>
                        <Link to="/Parentsnotification">
                          Parents Notification Settings
                        </Link>
                      </li>
                      <li>
                        <Link to="/integration">Integration Settings</Link>
                      </li>
                      <li>
                        <Link to="/accountant/invoicelayout">
                          Invoice Layout Settings
                        </Link>
                      </li>
                      <li>
                        <Link to="/accountant/receiptlayout">
                          Receipt Layout Settings
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li>
                  <a href="#!" onClick={() => toggleSubMenu("feeManagement")}>
                    <FontAwesomeIcon
                      icon={faGears}
                      size="sm"
                      style={{ marginRight: "8px" }}
                    />
                    <span className="title">Fee Management</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "feeManagement" && (
                    <ul className="sub-menu">
                      <li>
                        <Link to="/collectpayment">Collect Payment</Link>
                      </li>
                      <li>
                        <Link to="/UpcomingInvoices">Upcoming Invoices</Link>
                      </li>
                      <li>
                        <Link to="/PendingInvoices">Pending Invoices</Link>
                      </li>
                      {/* <li><Link to="/accountant/parenttransactions/success">Parent Paid Receipts</Link></li> */}
                     <li>
                        <Link to="/accountant/parenttransactions/receipt">
                          Receipt
                        </Link>
                      </li>
                      <li>
                        <Link to="/accountant/parenttransactions/failedpending">
                          Parent Failed Transactions
                        </Link>
                      </li>
                      <li>
                        <Link to="/CollectRegistrationFee">
                          Collect Registration Fee
                        </Link>
                      </li>
                      <li>
                        <Link to="/customer">Customer </Link>
                      </li>
                      {/* <li><Link to="/LoginPage">LoginPage</Link></li> */}
                    </ul>
                  )}
                </li>
{/* 
                   <li>
                  <a href="#!" onClick={() => toggleSubMenu("billsandexpense")}>
                    <FontAwesomeIcon
                      icon={faGears}
                      size="sm"
                      style={{ marginRight: "8px" }}
                    />
                    <span className="title">Bills And Expenses</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "billsandexpense" && (
                    <ul className="sub-menu">
                      <li>
                        <Link to="/accountant/bill">Bills</Link>
                      </li>
                      <li>
                        <Link to="/accountant/expenses">Expense22</Link>
                      </li>
                    
                    </ul>
                  )}
                </li> */}

                {/* Bills and Expenses */}
                <li>
                  <a href="#!" onClick={() => toggleSubMenu("billsExpenses")}>
                    <FontAwesomeIcon icon={faDollarSign}size="sm"  style={{  marginRight: '8px' }} />
                    <span className="title">Purchase Bills and Expenses</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "billsExpenses" && (
                    <ul className="sub-menu">
                      <li><Link to="/accountant/bill">Purchase Bills</Link></li>
                      <li><Link to="/accountant/OtherIncomes">Other Incomes</Link></li>
                      <li><Link to="/accountant/expenses">Expenses</Link></li>  
                      <li><Link to="/accountant/BankType">Banks</Link></li>  
                    </ul>
                  )}
                </li>

                {/* Smart Card Wallet */}
                {/* <li>
                  <a href="#!" onClick={() => toggleSubMenu("smartCardWallet")}>
                    <FontAwesomeIcon icon={faMoneyBill1} size="sm"  style={{  marginRight: '8px' }}/>
                    <span className="title">Smart Card Wallet</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "smartCardWallet" && (
                    <ul className="sub-menu">
                      <li><Link to="/accountant/Wallet_sale">Wallet Sale</Link></li>
                      <li><Link to="/accountant/wallet_recharges">Wallet Recharge</Link></li>
                      <li><Link to="/accountant/failed_recharge">Failed Recharge</Link></li>
                    </ul>
                  )}
                </li> */}
                {/* <li>
                  <a href="#!" onClick={() => toggleSubMenu("paymentProvider")}>
                    <FontAwesomeIcon icon={faMoneyBill1} size="sm"  style={{ marginRight: '8px' }}/>
                    <span className="title">Payment For Application</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "paymentProvider" && (
                    <ul className="sub-menu">
                      <li><Link to="/accountant/invoice">Invoices</Link></li>
                      <li><Link to="/accountant/payment">Paid</Link></li>
                      <li><Link to="/accountant/failedpayment">Failed Payments</Link></li>
                    </ul>
                  )}
                </li> */}
                {/* 
                <li>
                  <a href="#!" onClick={() => toggleSubMenu("parentTransactions")}>
                    <FontAwesomeIcon icon={faMoneyBill1} size="sm"  style={{  marginRight: '8px' }}/>
                    <span className="title">Parent Transactions</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "parentTransactions" && (
                    <ul className="sub-menu">
                        </ul>
                  )}
                </li> */}

                {/* <li>
                  <a href="#!" onClick={() => toggleSubMenu("vehicleExpenses")}>
                     <FontAwesomeIcon icon={faDollarSign} size="sm"  style={{ marginRight: '8px' }}/>
                    <span className="title">Vehicle Expenses</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "vehicleExpenses" && (
                    <ul className="sub-menu">
                    
                      <li><Link to="/fuelexpense">Fuel Expense</Link></li>
                      <li><Link to="/accountant/vehiclemaintenance">Vehicle Maintenance</Link></li>
                      <li><Link to="/accountant/vehicleincident">Vehicle Incident</Link></li>
                      <li><Link to="/accountant/vehiclefine">Vehicle Fine</Link></li>
                      <li><Link to="/accountant/vehicleaccessory">Vehicle Accessory</Link></li>
                      <li><Link to="/accountant/vehiclespareparts">Vehicle Spareparts</Link></li>
                    </ul>
                  )}
                </li> */}

                {/* Finance Section */}

                <li>
                  <a href="#!" onClick={() => toggleSubMenu("finance")}>
                    <FontAwesomeIcon icon={faMoneyBillTrendUp}size="sm"  style={{  marginRight: '8px' }} />
                    <span className="title">Finance</span>
                    <i className="icon-arrow"></i>
                  </a>
                  {openSubmenus === "finance" && (
                    <ul className="sub-menu">
                      <li><Link to="/accountant/finance/setup">Finance Setup</Link></li>
                      <li><Link to="/accountant/finance/chart-of-accounts">Chart of Accounts</Link></li>
                      <li><Link to="/accountant/finance/journal-entries">Journal Entries</Link></li>
                      <li><Link to="/accountant/finance/trial-balance">Trial Balance</Link></li>
                      <li><Link to="/accountant/finance/asset">Asset Register</Link></li>
                      <li><Link to="/accountant/finance/depreciation">Depreciation</Link></li>
                      <li><Link to="/accountant/liabilities">Liabilities</Link></li>
                      <li><Link to="/accountant/liabilities/payables">Accounts Payable</Link></li>
                      <li><Link to="/accountant/liabilities/loans">Loans</Link></li>
                      <li><Link to="/accountant/liabilities/salaries">Salaries Payable</Link></li>
                      <li><Link to="/accountant/finance/financial-statements">Financial Statements</Link></li>
                      <li><Link to="/accountant/finance/period-lock">Period Lock</Link></li>
                      <li><Link to="/accountant/finance/gl-tie-out">GL Tie-Out</Link></li>
                    </ul>
                  )}
                </li>

                <li>
                  <Link to="/accountant/reports/">
                     <FontAwesomeIcon icon={faFolderOpen} size="sm"  style={{marginRight: '8px' }}/>
                    <span className="title">Reports</span>
                  </Link>
                </li>

                <li>
                  <a
                    href="/login"
                    onClick={handleLogout}
                    style={{ cursor: "pointer", textDecoration: "none" }}
                  >
                    <FontAwesomeIcon
                      icon={faPowerOff}
                      size="sm"
                      style={{ marginRight: "8px" }}
                    />
                    <span className="title">Logout</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Footer profile section */}
        <div className="sidebar-footer">
          <div className="sidebar-footer-avatar">AC</div>
          <div className="sidebar-footer-text">
            <span className="sidebar-footer-name">Accountant Mode</span>
            <span className="sidebar-footer-status">Active Session</span>
          </div>
        </div>
      </aside>

      <main
        className={`content ${isSidebarOpen && isMobile ? "content-shifted" : ""}`}
      >
        <Header />
        <div>
          {children}

          {/* {login ? <></>:<></>} */}
        </div>
      </main>
    </div>
  );
};

export default RootLayout;
